export default __webpack_public_path__ + "static/media/numbers.1286de02.svg";